import RestaurantMenuGenerated, { RestaurantMenuGeneratedEntityManager } from './generated/RestaurantMenu.generated';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { imageInfoGraphQlDetails } from '@xFrame4/business/Constants';
import { YouTubeVideoInfo, ImageInfo } from '@xFrame4/business/Types';
import ImageGallery, { GalleryImage } from '@xFrame4/business/images/ImageGallery';
import { RestaurantMenuTranslation } from './RestaurantMenuTranslation';
import { BusinessEntityWithOrderNoHelper } from '@xFrame4/business/base/BusinessEntityWithOrderNoHelper';


export class RestaurantMenuEntityManager extends RestaurantMenuGeneratedEntityManager<RestaurantMenuTranslation, RestaurantMenu>
{
    static restaurantMenuItemLightGraphQlDetails = `
        id
        orderNo
        price
        primaryLanguage
        translations { 
            id 
            name 
            description 
        }
    `;

    constructor()
    {
        super({
            createEntity: () => new RestaurantMenu(),
            fields: [
                { name: 'menuItems', type: BusinessEntityFieldType.Custom, isInput: false, customGraphQl: RestaurantMenuEntityManager.restaurantMenuItemLightGraphQlDetails }
            ]
        });
    }

    
}


export class RestaurantMenu extends RestaurantMenuGenerated<RestaurantMenuTranslation>
{
    static _manager: RestaurantMenuEntityManager;
    static get manager(): RestaurantMenuEntityManager
    {
        if (!this._manager) this._manager = new RestaurantMenuEntityManager();
        return this._manager;
    }

    menuItems: RestaurantMenuItemLight[] = [];

    // override to parse numbers
    copyFromGraphQL(graphQlObject: any): void 
    {
        if (graphQlObject.menuItems != null)
        {
            graphQlObject.menuItems = graphQlObject.menuItems.map((item: any) => ({
                ...item,
                id: parseInt(item.id),
                orderNo: parseInt(item.orderNo),
                translations: item.translations.map((translation: any) => ({
                    ...translation,
                    id: parseInt(translation.id)
                }))
            }));
        }

        super.copyFromGraphQL(graphQlObject);
    }

    /**
     * Move the restaurant menu to a new position.
     * 
     * @param targetObject The target object to move the restaurant menu to.
     * @param before If true, the restaurant menu will be moved before the target object. If false, the restaurant menu will be moved after the target object.
     */
    async moveTo(targetObject: RestaurantMenu, before: boolean = true)
    {
        return BusinessEntityWithOrderNoHelper.moveTo('RestaurantMenu', this, targetObject, before);
    }
}

export type RestaurantMenuItemLight = {
    id: string;
    orderNo: number;
    price: number;
    primaryLanguage: string;
    translations: RestaurantMenuLightTranslation[];
}

export type RestaurantMenuLightTranslation = {
    id: string;
    name: string;
    description: string;
}

export default RestaurantMenu;